import { useEffect, useState } from "react";

/**
 * Tracks a CSS media query in JS. Used to drive the sidebar drawer transform
 * from state rather than Tailwind classes, because v4's `translate`-property
 * utilities don't override cleanly across responsive variants.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
